import posthog from "posthog-js";
import { capture } from "./capture";
import { contractProps } from "./contract";

export const AuthTracking = {
  /** Login form submitted. */
  loginSubmitted: (loginType: string) => {
    capture("auth.login_submitted", { login_type: loginType });
  },

  /** Login API succeeded. */
  loginSucceeded: (loginType: string, isOnboarded: boolean) => {
    capture("auth.login_succeeded", { login_type: loginType, is_onboarded: isOnboarded });
  },

  /** Login API failed. */
  loginFailed: (loginType: string, error: string) => {
    capture("auth.login_failed", { login_type: loginType, error });
  },

  /** Registration form submitted. `entryPoint` says where sign-up was entered from
   * (power-user, workspace, cli), when the URL said. */
  registerSubmitted: (registerType: string, entryPoint?: string) => {
    capture("auth.register_submitted", {
      ...contractProps(),
      register_type: registerType,
      ...(entryPoint === undefined ? {} : { entry_point: entryPoint }),
    });
  },

  /** Registration API succeeded. */
  registerSucceeded: (registerType: string, entryPoint?: string) => {
    capture("auth.register_succeeded", {
      ...contractProps(),
      register_type: registerType,
      ...(entryPoint === undefined ? {} : { entry_point: entryPoint }),
    });
  },

  /** Registration API failed. */
  registerFailed: (registerType: string, error: string) => {
    capture("auth.register_failed", { register_type: registerType, error });
  },

  /** An invited person's registration answered: they are in the tenant (workspace
   * event contract, stage 8). `workspaceId` when the invite carried one. */
  inviteAccepted: (workspaceId?: string | number) => {
    capture("invite_accepted", contractProps(workspaceId));
  },

  /** Free user instance created. */
  freeSignupInstanceCreated: (sourceInsight: string) => {
    capture("auth.free_signup_instance_created", { source_insight: sourceInsight });
  },

  /** Register CLI device context with PostHog for session correlation. */
  registerCliContext: (ctx: { machine_id?: string; cli_version?: string }) => {
    if (!ctx.machine_id) return;
    posthog.register({ cli_machine_id: ctx.machine_id, cli_version: ctx.cli_version ?? "" });
  },
};
